/**
 * Footer API service
 */

import { fetchStrapi } from './strapi';

export interface SocialLink {
  platform: string;
  url: string;
  icon: string;
}

export interface FooterLink {
  text: string;
  path: string;
}

export interface FooterSection {
  title: string;
  links: FooterLink[];
}

export interface Footer {
  brandName: string;
  brandIcon: string;
  brandDescription: string;
  socialLinks: SocialLink[];
  sections: FooterSection[];
  copyrightText: string;
  legalLinks: FooterLink[];
}

/**
 * Fetch footer data from Strapi
 */
export async function fetchFooter(): Promise<Footer | null> {
  try {
    // Use nested populate to get links inside sections and legalLinks
    const response = await fetchStrapi<any>(
      '/footer?populate[socialLinks]=*&populate[bereiche][populate][0]=links&populate[rechtlicheLinks]=*'
    );

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      brandName: data.markenName || 'Gerald Fasching',
      brandIcon: data.markenIcon || 'ri-fire-line',
      brandDescription: data.markenBeschreibung || '',
      socialLinks: (data.socialLinks || []).map((s: any) => ({
        platform: s.plattform,
        url: s.url,
        icon: s.icon,
      })),
      sections: (data.bereiche || []).map((b: any) => ({
        title: b.titel,
        links: (b.links || []).map((l: any) => ({
          text: l.text,
          path: l.path,
        })),
      })),
      copyrightText: data.copyrightText || '',
      legalLinks: (data.rechtlicheLinks || []).map((r: any) => ({
        text: r.text,
        path: r.path,
      })),
    };
  } catch (error) {
    console.error('Error fetching footer from Strapi:', error);
    return null;
  }
}

